import React, { useContext, useEffect } from 'react'
import { ContextOperacion, ContextOperacionType } from '../../RefactorLayout'
import { useOperacionWRC } from './hooks'
import { useLoader } from 'src/hooks/useLoader'
import {Alert, Grid} from '@mui/material'
import { SeccionWRCDatosOperacion, SeccionWRCDetalle } from './components'
import { EntityWithIdFields, QueryStatus } from 'src/types'
import { SubmitHandler, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { HttpWRC, OperacionWRC } from './api'
import { FormOperacionWRC, schemaFormOperacionWRC } from './types/types'
import toast from 'react-hot-toast'
import { SeccionFirmas } from '../../components/SeccionFirmas'
import {SistemaTipo} from "../../../../types/enum/enum";

type SistemaWRCreditoContentProps = {
    operacion: OperacionWRC,
}


const SistemaWRCreditoContent = ({ operacion }: SistemaWRCreditoContentProps) => {

    const { setSavePromise, codSistemaTipo: codSistema } = useContext<ContextOperacionType>(ContextOperacion)

    const formMethods = useForm<FormOperacionWRC>({
        resolver: zodResolver(schemaFormOperacionWRC),
        values: { ...operacion }
    })

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (operacion.permiteEditarOperacion) {
            const handleSave: SubmitHandler<FormOperacionWRC> = (data) => {
                showLoader()
                const promise = HttpWRC.put(operacion.id, data)

                toast.promise(promise, {
                    loading: 'Guardando.',
                    success: 'Guardado correctamente.',
                    error: e => `${e}`
                })
                    .finally(hideLoader)
            }

            const onSave = () => formMethods.handleSubmit(handleSave)
            setSavePromise(onSave)
        }
    }, [])


    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <SeccionWRCDatosOperacion
                        formMethods={formMethods}
                        readOnly={!operacion.permiteEditarOperacion}
                        operacion={operacion}
                        codSistemaPrincipal={operacion.codPais}
                        codSistema={codSistema}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionWRCDetalle
                        idOperacion={operacion[EntityWithIdFields.Id]}
                        idPais={operacion.codPais}
                        permiteEditar={operacion.permiteEditarOperacion}
                        permiteEliminar={operacion.permiteEliminarOperacion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionFirmas
                        codSistema={SistemaTipo.MinutaCredito}
                        idOperacion={operacion[EntityWithIdFields.Id]}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export const SistemaWRCredito = () => {

    const { idOperacion } = useContext<ContextOperacionType>(ContextOperacion)

    const { status, operacion } = useOperacionWRC(idOperacion)

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (status === QueryStatus.Loading) {
            showLoader()
        } else {
            hideLoader();
        }
    }, [status])

    if (!operacion) {
        return (
            <></>
        )
    }

    if (status === QueryStatus.Error) {
        return (
            <Alert severity='error'>
                Se produjo un error al cargar la operación.
            </Alert>
        )
    }

    return (
        <SistemaWRCreditoContent
            operacion={operacion}

        // setSavePromise={setSavePromise}
        // setCrearInforme={setCrearInforme}
        />
    )
}
